import axios from '../axios';
import api from '../api.mappings';
export class WechatApi {
    sign(params) {
        return axios.get(api.wechat.sign, {
            params
        });
    }
    login(params) {
        return axios.get(api.wechat.login, {
            params
        });
    }
}
